import { ReactNode } from "react";
import cx from "classnames";

import { Transition } from "common/hooks";

import styles from "../../styles/deprecated/Overlay.module.less";

type OverlayProps = {
  children: ReactNode;
  isVisible?: boolean;
  transition: Transition;
  onClose: () => void;
  className?: string;
};

/**
 * @deprecated Replaced by Stackables
 * @see {@link stackables/hooks} for new implementation
 */
const Overlay = ({ children, isVisible = true, transition, onClose, className }: OverlayProps) => {
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  const handleMouseDown = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  return (
    <div
      className={cx(
        styles.container,
        styles[`container-${transition.transitionState}`],
        isVisible && styles.visible,
        className,
      )}
      style={{ transitionDuration: transition.durationStyle }}
      onMouseDown={handleMouseDown}
      onKeyDown={handleKeyPress}
      tabIndex={0}
      role="button"
    >
      {children}
    </div>
  );
};

export default Overlay;
